import alternativeEmailGradient from './svgs/alternativeEmailGradient.svg';
import infoBlueGradient from './svgs/infoBlueGradient.svg';
import moveToInboxBlueGradient from './svgs/moveToInboxBlueGradient.svg';
import swapHorizontalCircleBlueGradient from './svgs/swapHorizontalCircleBlueGradient.svg';
import ach from './svgs/ach.svg';
import account from './svgs/account.svg';
import accountActivitySummary from './svgs/accountActivitySummary.svg';
import accountActivitySummaryOn from './svgs/accountActivitySummaryOn.svg';
import accountList from './svgs/accountList.svg';
import accountListOn from './svgs/accountListOn.svg';
import accounts from './svgs/accounts.svg';
import accountsOn from './svgs/accountsOn.svg';
import accountBilling from './svgs/accountBilling.svg';
import accountBillingOn from './svgs/accountBillingOn.svg';
import accountTransfer from './svgs/accountTransfer.svg';
import accountTransferOn from './svgs/accountTransferOn.svg';
import accountSettings from './svgs/accountSettings.svg';
import accountSettingsOn from './svgs/accountSettingsOn.svg';
import aicpaSoc from './svgs/aicpaSoc.svg';
import applePay from './svgs/applepay.svg';
import approvalInbox from './svgs/approvalInbox.svg';
import approvalInboxOn from './svgs/approvalInboxOn.svg';
import activity from './svgs/activity.svg';
import approvalList from './svgs/approvalList.svg';
import approvalListOn from './svgs/approvalListOn.svg';
import transactionApproval from './svgs/transactionApproval.svg';
import transactionApprovalOn from './svgs/transactionApprovalOn.svg';
import approvalConfiguration from './svgs/approvalConfiguration.svg';
import approvalConfigurationOn from './svgs/approvalConfigurationOn.svg';
import add from './svgs/add.svg';
import addAccount from './svgs/addAccount.svg';
import addAccountOn from './svgs/addAccountOn.svg';
import addContact from './svgs/addContact.svg';
import addContactOn from './svgs/addContactOn.svg';
import addNewClientAccount from './svgs/addNewClientAccount.svg';
import addNewClientAccountOn from './svgs/addNewClientAccountOn.svg';
import addPackage from './svgs/addPackage.svg';
import addPackageOn from './svgs/addPackageOn.svg';
import alarm from './svgs/alarm.svg';
import angleDown from './svgs/angle-down.svg';
import angleDown2 from './svgs/angle-down2.svg';
import angleLeft from './svgs/angle-left.svg';
import angleRight from './svgs/angle-right.svg';
import arrowDown from './svgs/arrow-down.svg';
import arrowDown2 from './svgs/arrow-down2.svg';
import arrowLeft from './svgs/arrow-left.svg';
import angleTop from './svgs/angle-top.svg';
import arrowRight from './svgs/arrow-right.svg';
import arrowSmallRight from './svgs/arrow-small-right.svg';
import arrowTop from './svgs/arrow-top.svg';
import arrowUp from './svgs/arrow-up.svg';
import asterisk from './svgs/asterisk.svg';
import autoBalance from './svgs/autoBalance.svg';
import autoBalanceOn from './svgs/autoBalanceOn.svg';
import autoBalanceTransfer from './svgs/autoBalanceTransfer.svg';
import autoBalanceTransferOn from './svgs/autoBalanceTransferOn.svg';
import accountingCredits from './svgs/accountingCredits.svg';
import accountingSoftware from './svgs/accountingSoftware.svg';
import bank from './svgs/bank.svg';
import badgeBlueGradient from './svgs/badgeBlueGradient.svg';
import bankDark from './svgs/bankDark.svg';
import bankOn from './svgs/bankOn.svg';
import bankAccount from './svgs/bankAccount.svg';
import bank2 from './svgs/bank2.svg';
import bank3 from './svgs/bank3.svg';
import bank4 from './svgs/bank4.svg';
import bankAccountTransfer from './svgs/bankAccountTransfer.svg';
import bankAccountTransferOn from './svgs/bankAccountTransferOn.svg';
import bankVerifyHistory from './svgs/bankVerifyHistory.svg';
import bankVerifyHistoryOn from './svgs/bankVerifyHistoryOn.svg';
import bill from './svgs/bill.svg';
import billing from './svgs/billing.svg';
import billingOn from './svgs/billingOn.svg';
import blockRed from './svgs/blockRed.svg';
import briefcase from './svgs/briefcase.svg';
import briefcaseOn from './svgs/briefcaseOn.svg';
import bulkCollection from './svgs/bulkCollection.svg';
import bulkCollectionOn from './svgs/bulkCollectionOn.svg';
import bulkPayment from './svgs/bulkPayment.svg';
import bulkPaymentOn from './svgs/bulkPaymentOn.svg';
import business from './svgs/business.svg';
import businessAvatar from './svgs/businessAvatar.svg';
import businessAvatarInactive from './svgs/businessAvatarInactive.svg';
import calendar from './svgs/calendar.svg';
import can from './svgs/can.svg';
import calendar2 from './svgs/calendar2.svg';
import calendarAccounting from './svgs/calendarAccounting.svg';
import calendarPremium from './svgs/calendarPremium.svg';
import calendarSchedule from './svgs/calendarSchedule.svg';
import card from './svgs/card.svg';
import cashPickup from './svgs/cashPickup.svg';
import cardAE from './svgs/card_ae.svg';
import cardDiscover from './svgs/card_discover.svg';
import cardMaster from './svgs/card_master.svg';
import cardMaster2 from './svgs/card_master2.svg';
import cardVisa from './svgs/card_visa.svg';
import cardVisa2 from './svgs/card_visa2.svg';
import cardDiners from './svgs/cardDiners.svg';
import cardJcb from './svgs/cardJcb.svg';
import cautionary from './svgs/cautionary.svg';
import cautionary2 from './svgs/cautionary2.svg';
import chat from './svgs/chat.svg';
import check from './svgs/check.svg';
import check2 from './svgs/check2.svg';
import checkboxCheck from './svgs/checkboxCheck.svg';
import checkGreen from './svgs/checkGreen.svg';
import chevron from './svgs/chevron.svg';
import checkGreenCircle from './svgs/checkGreenCircle.svg';
import checkBlueGradient from './svgs/checkBlueGradient.svg';
import clientAccountList from './svgs/clientAccountList.svg';
import clientAccountListOn from './svgs/clientAccountListOn.svg';
import clientAccounts from './svgs/clientAccounts.svg';
import clientAccountsOn from './svgs/clientAccountsOn.svg';
import clock from './svgs/clock.svg';
import close from './svgs/close.svg';
import close2 from './svgs/close2.svg';
import coin from './svgs/coin.svg';
import collaborators from './svgs/collaborators.svg';
import completed from './svgs/completed.svg';
import collection from './svgs/collection.svg';
import collectionOn from './svgs/collectionOn.svg';
import connections from './svgs/connections.svg';
import connectionOn from './svgs/connectionsOn.svg';
import contacts from './svgs/contacts.svg';
import contactsOn from './svgs/contactsOn.svg';
import contactsDownload from './svgs/contactsDownload.svg';
import contactsDownloadOn from './svgs/contactsDownloadOn.svg';
import contactsGradient from './svgs/contacts-gradient.svg';
import contactsUpload from './svgs/contactsUpload.svg';
import contactsUploadOn from './svgs/contactsUploadOn.svg';
import conversion from './svgs/conversion.svg';
import conversionOn from './svgs/conversionOn.svg';
import convert from './svgs/convert.svg';
import convertOn from './svgs/convertOn.svg';
import convertArrow from './svgs/convertArrow.svg';
import copy from './svgs/copy.svg';
import counter from './svgs/counter.svg';
import cross from './svgs/cross.svg';
import crossborder from './svgs/crossborder.svg';
import crossborderOn from './svgs/crossborderOn.svg';
import create from './svgs/create.svg';
import createSubAccount from './svgs/createSubAccount.svg';
import createSubAccountOn from './svgs/createSubAccountOn.svg';
import creditCard from './svgs/credit_card.svg';
import creditCard2 from './svgs/credit_card2.svg';
import creditCard3 from './svgs/credit_card3.svg';
import creditCard4 from './svgs/credit_card4.svg';
import dashboardSmall from './svgs/dashboard-small.svg';
import dashboardSmallOn from './svgs/dashboard-smallOn.svg';
import dashboard from './svgs/dashboard.svg';
import dashboardOn from './svgs/dashboardOn.svg';
import dateCalendar from './svgs/date-calendar.svg';
import developer from './svgs/developer.svg';
import developerDoc from './svgs/developerDoc.svg';
import developerOn from './svgs/developerOn.svg';
import development from './svgs/development.svg';
import dialogSuccess from './svgs/dialogSuccess.svg';
import dispute from './svgs/dispute.svg';
import document from './svgs/document.svg';
import document2 from './svgs/document2.svg';
import document3 from './svgs/document3.svg';
import document4 from './svgs/document4.svg';
import documentBulletPoints from './svgs/documentBulletPoints.svg';
import docuUpload from './svgs/docuUpload.svg';
import dollar from './svgs/dollar.svg';
import dollarCoin from './svgs/dollarCoin.svg';
import download from './svgs/download.svg';
import edit from './svgs/edit.svg';
import edit2 from './svgs/edit2.svg';
import eLinxHistory from './svgs/eLinxHistory.svg';
import eLinxHistoryOn from './svgs/eLinxHistoryOn.svg';
import emptyBox from './svgs/emptyBox.svg';
import error from './svgs/error.svg';
import error2 from './svgs/error2.svg';
import error3 from './svgs/error3.svg';
import exclamation from './svgs/exclamation.svg';
import errorRed from './svgs/errorRed.svg';
import errorRed2 from './svgs/errorRed2.svg';
import expand from './svgs/expand.svg';
import eyeClose from './svgs/eyeClose.svg';
import eyeOpen from './svgs/eyeOpen.svg';
import ePay from './svgs/ePay.svg';
import eCollect from './svgs/eCollect.svg';
import eConnect from './svgs/eConnect.svg';
import eFlex from './svgs/eFlex.svg';
import ePayOn from './svgs/ePayOn.svg';
import eCollectOn from './svgs/eCollectOn.svg';
import eConnectOn from './svgs/eConnectOn.svg';
import eFlexOn from './svgs/eFlexOn.svg';
import eft from './svgs/eft.svg';
import facebook from './svgs/facebook.svg';
import fail from './svgs/fail.svg';
import fail2 from './svgs/fail2.svg';
import fail3 from './svgs/fail3.svg';
import faq from './svgs/faq.svg';
import faq2 from './svgs/faq2.svg';
import faq3 from './svgs/faq3.svg';
import faqOn from './svgs/faqOn.svg';
import fednow from './svgs/fednow.svg';
import fileDownload from './svgs/fileDownload.svg';
import fileDownloadOn from './svgs/fileDownloadOn.svg';
import fileUpload from './svgs/fileUpload.svg';
import fileUploadOn from './svgs/fileUploadOn.svg';
import filter from './svgs/filter.svg';
import filter2 from './svgs/filter2.svg';
import filter2on from './svgs/filter2on.svg';
import folder from './svgs/folder.svg';
import folderOn from './svgs/folderOn.svg';
import fund from './svgs/fund.svg';
import fundOn from './svgs/fundOn.svg';
import global from './svgs/global.svg';
import globe from './svgs/globe.svg';
import google from './svgs/google.svg';
import googlePay from './svgs/googlepay.svg';
import graphIncreasing from './svgs/graph_increasing.svg';
import gridSquares from './svgs/grid-squares.svg';
import gridSquaresAdd from './svgs/grid-squares-add.svg';
import homeDoor from './svgs/home-door.svg';
import home from './svgs/home.svg';
import iconsGradient from './svgs/iconsGradient.svg';
import inactive from './svgs/inactive.svg';
import income from './svgs/income.svg';
import information from './svgs/information.svg';
import infoCircle from './svgs/infoCircle.svg';
import interac from './svgs/Interac.svg';
import interacColor from './svgs/InteracColor.svg';
import interac2 from './svgs/interac2.svg';
import interestBank from './svgs/interestBank.svg';
import interacYellow from './svgs/interacYellow.svg';
import invoice from './svgs/invoice.svg';
import invoiceOn from './svgs/invoiceOn.svg';
import learningCenter from './svgs/learningCenter.svg';
import learningCenterOn from './svgs/learningCenterOn.svg';
import legoCyclopsMoustache from './svgs/legoCyclopsMoustache.svg';
import line from './svgs/line.svg';
import linkedin from './svgs/linkedin.svg';
import loader from './svgs/loader.svg';
import loaderCropped from './svgs/loaderCropped.svg';
import lock from './svgs/lock.svg';
import lock2 from './svgs/lock2.svg';
import logoELinx from './svgs/logo-eLinx.svg';
import logOut from './svgs/logOut.svg';
import logOutOn from './svgs/logOutOn.svg';
import magnifyingGlass from './svgs/magnifyingGlass.svg';
import mail from './svgs/mail.svg';
import mailGradient from './svgs/mailGradient.svg';
import mobileMoney from './svgs/mobileMoney.svg';
import mailOutline from './svgs/mailOutline.svg';
import mobile from './svgs/mobile.svg';
import moneyCalendar from './svgs/money_calendar.svg';
import moneyCardPen from './svgs/money-card-pen.svg';
import money from './svgs/money.svg';
import moneyOn from './svgs/moneyOn.svg';
import multiply from './svgs/multiply.svg';
import multiBank from './svgs/multiBank.svg';
import notAllowed from './svgs/notAllowed.svg';
import pen from './svgs/pen.svg';
import pending from './svgs/pending.svg';
import pendingClear from './svgs/pendingClear.svg';
import myAccount from './svgs/myAccount.svg';
import myAccountOn from './svgs/myAccountOn.svg';
import myTeam from './svgs/myTeam.svg';
import myTeamOn from './svgs/myTeamOn.svg';
import operationalAccounts from './svgs/operationalAccounts.svg';
import operationalAccountsOn from './svgs/operationalAccountsOn.svg';
import outcome from './svgs/outcome.svg';
import packages from './svgs/packages.svg';
import packagesOn from './svgs/packagesOn.svg';
import password from './svgs/password.svg';
import payables from './svgs/payables.svg';
import payablesOn from './svgs/payablesOn.svg';
import paylink from './svgs/paylink.svg';
import paylinkOn from './svgs/paylinkOn.svg';
import payment from './svgs/payment.svg';
import paymentOn from './svgs/paymentOn.svg';
import paymentCard from './svgs/paymentCard.svg';
import paypal from './svgs/paypal.svg';
import paypal2 from './svgs/paypal2.svg';
import pci from './svgs/pci.svg';
import pci2 from './svgs/pci2.svg';
import pdfActive from './svgs/pdfActive.svg';
import percentage from './svgs/percentage.svg';
import personAvatar from './svgs/personAvatar.svg';
import personAvatarInactive from './svgs/personAvatarInactive.svg';
import personal from './svgs/personal.svg';
import phoneGradient from './svgs/phoneGradient.svg';
import picture from './svgs/picture.svg';
import positive from './svgs/positive.svg';
import photo from './svgs/photo.svg';
import production from './svgs/production.svg';
import pull from './svgs/pull.svg';
import question from './svgs/question.svg';
import profile from './svgs/profile.svg';
import profile2 from './svgs/profile2.svg';
import receipt from './svgs/receipt.svg';
import receivables from './svgs/receivables.svg';
import receivablesOn from './svgs/receivablesOn.svg';
import refresh from './svgs/refresh.svg';
import reports from './svgs/reports.svg';
import reportsOn from './svgs/reportsOn.svg';
import rtp from './svgs/rtp.svg';
import sandbox from './svgs/sandbox.svg';
import scheduled from './svgs/scheduled.svg';
import scheduledOn from './svgs/scheduledOn.svg';
import scheduledClientAccountTransfers from './svgs/scheduledClientAccountTransfers.svg';
import scheduledClientAccountTransfersOn from './svgs/scheduledClientAccountTransfersOn.svg';
import search from './svgs/search.svg';
import search2 from './svgs/search2.svg';
import searchData from './svgs/search-data.svg';
import searchGradient from './svgs/search-gradient.svg';
import serviceGlobalTransfer from './svgs/service_global_transfer.svg';
import switchDisable from './svgs/switch_disable.svg';
import switchEnable from './svgs/switch_enable.svg';
import setting from './svgs/setting.svg';
import setting2 from './svgs/setting2.svg';
import settingOn from './svgs/settingOn.svg';
import sign from './svgs/sign.svg';
import soc from './svgs/soc.svg';
import star from './svgs/star.svg';
import starOutline from './svgs/starOutline.svg';
import statePositive from './svgs/statePositive.svg';
import stateNeutral from './svgs/stateNeutral.svg';
import stateInfo from './svgs/stateInfo.svg';
import stateNegative from './svgs/stateNegative.svg';
import subAccount from './svgs/subAccount.svg';
import subAccountOn from './svgs/subAccountOn.svg';
import subAccountsList from './svgs/subAccountsList.svg';
import subAccountsListOn from './svgs/subAccountsListOn.svg';
import subTract from './svgs/subTract.svg';
import summary from './svgs/summary.svg';
import summaryOn from './svgs/summaryOn.svg';
import support from './svgs/support.svg';
import supportOn from './svgs/supportOn.svg';
import swap from './svgs/swap.svg';
import sync from './svgs/sync.svg';
import ticket from './svgs/ticket.svg';
import ticketOn from './svgs/ticketOn.svg';
import ticketList from './svgs/ticketList.svg';
import ticketListOn from './svgs/ticketListOn.svg';
import training from './svgs/training.svg';
import trainingOn from './svgs/trainingOn.svg';
import transactionPending from './svgs/transactionPending.svg';
import transactions from './svgs/transactions.svg';
import transactionsOn from './svgs/transactionsOn.svg';
import transactionsHistory from './svgs/transactionsHistory.svg';
import transactionsHistoryOn from './svgs/transactionsHistoryOn.svg';
import transfer from './svgs/transfer.svg';
import transferOn from './svgs/transferOn.svg';
import trashcan from './svgs/trashcan.svg';
import transferFunds from './svgs/transferFunds.svg';
import transferFundsOn from './svgs/transferFundsOn.svg';
import trash from './svgs/trash.svg';
import unSelectAll from './svgs/unSelectAll.svg';
import upload from './svgs/upload.svg';
import uploadHistory from './svgs/uploadHistory.svg';
import uploadHistoryOn from './svgs/uploadHistoryOn.svg';
import uploadOn from './svgs/uploadOn.svg';
import vLogo from './svgs/v-logo.svg';
import vLogoText from './svgs/v-logo-vertical.svg';
import vLogoMark from './svgs/v-logomark.svg';
import vector from './svgs/vector.svg';
import venmo from './svgs/venmo.svg';
import venmo2 from './svgs/venmo2.svg';
import video from './svgs/video.svg';
import videoDisabled from './svgs/videoDisabled.svg';
import vopayLogo from './svgs/vopay-logo.svg';
import user from './svgs/user.svg';
import userSettings from './svgs/userSettings.svg';
import userSettingsOn from './svgs/userSettingsOn.svg';
import wallet from './svgs/wallet.svg';
import walletOn from './svgs/walletOn.svg';
import warning from './svgs/warning.svg';
import withdraw from './svgs/withdraw.svg';
import withdrawOn from './svgs/withdrawOn.svg';
import write from './svgs/write.svg';
import i from './svgs/i.svg';
import iOutlined from './svgs/i_outlined.svg';
import eLinxE from './svgs/eLinxE.svg';
import eLinxLogo from './svgs/eLinxLogo.svg';
import importExport from './svgs/importExport.svg';
import checkCircleFilled from './svgs/checkCircleFilled.svg';
import pendingStatus from './svgs/pendingStatus.svg';

/* Alphabetical Order */

export type Icons =
  | 'infoBlueGradient'
  | 'moveToInboxBlueGradient'
  | 'swapHorizontalCircleBlueGradient'
  | 'alternativeEmailGradient'
  | 'ach'
  | 'account'
  | 'accountActivitySummary'
  | 'accountActivitySummaryOn'
  | 'accountBilling'
  | 'accountBillingOn'
  | 'accountList'
  | 'accountListOn'
  | 'accounts'
  | 'accountsOn'
  | 'accountingCredits'
  | 'accountingSoftware'
  | 'add'
  | 'addAccount'
  | 'addAccountOn'
  | 'addContact'
  | 'addContactOn'
  | 'addNewClientAccount'
  | 'addNewClientAccountOn'
  | 'accountTransfer'
  | 'accountTransferOn'
  | 'accountSettings'
  | 'accountSettingsOn'
  | 'aicpaSoc'
  | 'addPackage'
  | 'addPackageOn'
  | 'approvalInbox'
  | 'approvalInboxOn'
  | 'activity'
  | 'applePay'
  | 'approvalList'
  | 'approvalListOn'
  | 'transactionApproval'
  | 'transactionApprovalOn'
  | 'approvalConfiguration'
  | 'approvalConfigurationOn'
  | 'alarm'
  | 'angleDown'
  | 'angleDown2'
  | 'angleLeft'
  | 'angleRight'
  | 'arrowDown'
  | 'arrowDown2'
  | 'arrowLeft'
  | 'angleTop'
  | 'arrowUp'
  | 'arrowRight'
  | 'arrowSmallRight'
  | 'arrowTop'
  | 'asterisk'
  | 'autoBalance'
  | 'autoBalanceOn'
  | 'autoBalanceTransfer'
  | 'autoBalanceTransferOn'
  | 'badgeBlueGradient'
  | 'bank'
  | 'bank2'
  | 'bank3'
  | 'bank4'
  | 'bankDark'
  | 'bankOn'
  | 'bankAccount'
  | 'bankAccountTransfer'
  | 'bankAccountTransferOn'
  | 'bankVerifyHistory'
  | 'bankVerifyHistoryOn'
  | 'bill'
  | 'billing'
  | 'billingOn'
  | 'blockRed'
  | 'briefcase'
  | 'briefcaseOn'
  | 'bulkCollection'
  | 'bulkCollectionOn'
  | 'bulkPayment'
  | 'bulkPaymentOn'
  | 'paypal'
  | 'paypal2'
  | 'pci'
  | 'pci2'
  | 'business'
  | 'businessAvatar'
  | 'businessAvatarInactive'
  | 'calendar'
  | 'can'
  | 'calendar2'
  | 'calendarAccounting'
  | 'calendarPremium'
  | 'calendarSchedule'
  | 'card'
  | 'cashPickup'
  | 'cardAE'
  | 'cardDiscover'
  | 'cardMaster'
  | 'cardMaster2'
  | 'cardVisa'
  | 'cardVisa2'
  | 'cardDiners'
  | 'cardJcb'
  | 'cautionary'
  | 'cautionary2'
  | 'chat'
  | 'check'
  | 'check2'
  | 'checkboxCheck'
  | 'checkGreen'
  | 'chevron'
  | 'checkGreenCircle'
  | 'checkBlueGradient'
  | 'clientAccountList'
  | 'clientAccountListOn'
  | 'clientAccounts'
  | 'clientAccountsOn'
  | 'clock'
  | 'close'
  | 'close2'
  | 'coin'
  | 'collaborators'
  | 'completed'
  | 'collection'
  | 'collectionOn'
  | 'connections'
  | 'connectionsOn'
  | 'contacts'
  | 'contactsOn'
  | 'contactsDownload'
  | 'contactsDownloadOn'
  | 'contactsGradient'
  | 'contactsUpload'
  | 'contactsUploadOn'
  | 'conversion'
  | 'conversionOn'
  | 'convert'
  | 'convertOn'
  | 'convertArrow'
  | 'copy'
  | 'counter'
  | 'cross'
  | 'crossborder'
  | 'crossborderOn'
  | 'create'
  | 'createSubAccount'
  | 'createSubAccountOn'
  | 'creditCard'
  | 'creditCard2'
  | 'creditCard3'
  | 'creditCard4'
  | 'dashboardSmall'
  | 'dashboardSmallOn'
  | 'dashboard'
  | 'dashboardOn'
  | 'dateCalendar'
  | 'developer'
  | 'developerDoc'
  | 'developerOn'
  | 'development'
  | 'dialogSuccess'
  | 'dispute'
  | 'document'
  | 'document2'
  | 'document3'
  | 'document4'
  | 'documentBulletPoints'
  | 'docuUpload'
  | 'dollar'
  | 'dollarCoin'
  | 'download'
  | 'edit'
  | 'edit2'
  | 'eLinxHistory'
  | 'eLinxHistoryOn'
  | 'eft'
  | 'emptyBox'
  | 'error'
  | 'error2'
  | 'error3'
  | 'exclamation'
  | 'errorRed'
  | 'errorRed2'
  | 'expand'
  | 'eyeClose'
  | 'eyeOpen'
  | 'ePay'
  | 'eConnect'
  | 'eCollect'
  | 'eFlex'
  | 'ePayOn'
  | 'eConnectOn'
  | 'eCollectOn'
  | 'eFlexOn'
  | 'facebook'
  | 'fail'
  | 'fail2'
  | 'fail3'
  | 'faq'
  | 'faq2'
  | 'faq3'
  | 'faqOn'
  | 'fednow'
  | 'fileDownload'
  | 'fileDownloadOn'
  | 'fileUpload'
  | 'fileUploadOn'
  | 'filter'
  | 'filter2'
  | 'filter2on'
  | 'folder'
  | 'folderOn'
  | 'fund'
  | 'fundOn'
  | 'global'
  | 'globe'
  | 'google'
  | 'googlePay'
  | 'graphIncreasing'
  | 'gridSquares'
  | 'gridSquaresAdd'
  | 'homeDoor'
  | 'home'
  | 'iconsGradient'
  | 'inactive'
  | 'income'
  | 'information'
  | 'infoCircle'
  | 'interac'
  | 'interacColor'
  | 'interac2'
  | 'interestBank'
  | 'interacYellow'
  | 'invoice'
  | 'invoiceOn'
  | 'learningCenter'
  | 'learningCenterOn'
  | 'legoCyclopsMoustache'
  | 'line'
  | 'linkedin'
  | 'line'
  | 'loader'
  | 'loaderCropped'
  | 'lock'
  | 'lock2'
  | 'logoELinx'
  | 'logOut'
  | 'logOutOn'
  | 'magnifyingGlass'
  | 'mail'
  | 'mailGradient'
  | 'mobileMoney'
  | 'mailOutline'
  | 'mobile'
  | 'moneyCalendar'
  | 'moneyCardPen'
  | 'money'
  | 'moneyOn'
  | 'multiply'
  | 'pen'
  | 'pending'
  | 'pendingClear'
  | 'multiBank'
  | 'myAccount'
  | 'myAccountOn'
  | 'myTeam'
  | 'myTeamOn'
  | 'notAllowed'
  | 'operationalAccounts'
  | 'operationalAccountsOn'
  | 'outcome'
  | 'packages'
  | 'packagesOn'
  | 'password'
  | 'payables'
  | 'payablesOn'
  | 'paylink'
  | 'paylinkOn'
  | 'payment'
  | 'paymentOn'
  | 'paymentCard'
  | 'pdfActive'
  | 'percentage'
  | 'personAvatar'
  | 'personAvatarInactive'
  | 'personal'
  | 'phoneGradient'
  | 'picture'
  | 'positive'
  | 'photo'
  | 'production'
  | 'pull'
  | 'question'
  | 'profile'
  | 'profile2'
  | 'question'
  | 'receipt'
  | 'receivables'
  | 'receivablesOn'
  | 'refresh'
  | 'reports'
  | 'reportsOn'
  | 'rtp'
  | 'sandbox'
  | 'scheduled'
  | 'scheduledOn'
  | 'scheduledClientAccountTransfers'
  | 'scheduledClientAccountTransfersOn'
  | 'search'
  | 'search2'
  | 'searchData'
  | 'searchGradient'
  | 'serviceGlobalTransfer'
  | 'switchDisable'
  | 'switchEnable'
  | 'setting'
  | 'setting2'
  | 'settingOn'
  | 'sign'
  | 'soc'
  | 'star'
  | 'starOutline'
  | 'statePositive'
  | 'stateNeutral'
  | 'stateInfo'
  | 'stateNegative'
  | 'subAccount'
  | 'subAccountOn'
  | 'subAccountsList'
  | 'subAccountsListOn'
  | 'subTract'
  | 'summary'
  | 'summaryOn'
  | 'support'
  | 'supportOn'
  | 'swap'
  | 'sync'
  | 'ticket'
  | 'ticketOn'
  | 'ticketList'
  | 'ticketListOn'
  | 'training'
  | 'trainingOn'
  | 'transactionPending'
  | 'transactions'
  | 'transactionsOn'
  | 'transactionsHistory'
  | 'transactionsHistoryOn'
  | 'transfer'
  | 'transferOn'
  | 'trashcan'
  | 'transferFunds'
  | 'transferFundsOn'
  | 'trash'
  | 'unSelectAll'
  | 'upload'
  | 'uploadHistory'
  | 'uploadHistoryOn'
  | 'uploadOn'
  | 'vLogo'
  | 'vLogoText'
  | 'vLogoMark'
  | 'vector'
  | 'venmo'
  | 'venmo2'
  | 'video'
  | 'videoDisabled'
  | 'vopayLogo'
  | 'upload'
  | 'user'
  | 'userSettings'
  | 'userSettingsOn'
  | 'wallet'
  | 'walletOn'
  | 'warning'
  | 'withdraw'
  | 'withdrawOn'
  | 'write'
  | 'i'
  | 'iOutlined'
  | 'eLinxE'
  | 'eLinxLogo'
  | 'importExport'
  | 'checkCircleFilled'
  | 'pendingStatus';
export const iconMap: { [key in Icons]: { src: string; alt: string } } = {
  account: {
    src: account,
    alt: 'account',
  },
  infoBlueGradient: {
    src: infoBlueGradient,
    alt: 'infoBlueGradient',
  },
  moveToInboxBlueGradient: {
    src: moveToInboxBlueGradient,
    alt: 'moveToInboxBlueGradient',
  },
  swapHorizontalCircleBlueGradient: {
    src: swapHorizontalCircleBlueGradient,
    alt: 'swapHorizontalCircleBlueGradient',
  },
  alternativeEmailGradient: {
    src: alternativeEmailGradient,
    alt: 'alternativeEmailGradient',
  },
  ach: {
    src: ach,
    alt: 'ach',
  },
  accountActivitySummary: {
    src: accountActivitySummary,
    alt: 'accountActivitySummary',
  },
  accountActivitySummaryOn: {
    src: accountActivitySummaryOn,
    alt: 'accountActivitySummary-on',
  },
  accountBilling: {
    src: accountBilling,
    alt: 'accountBilling',
  },
  accountBillingOn: {
    src: accountBillingOn,
    alt: 'accountBilling-on',
  },
  accountList: {
    src: accountList,
    alt: 'accountList',
  },
  accountListOn: {
    src: accountListOn,
    alt: 'accountList-on',
  },
  accountingCredits: {
    src: accountingCredits,
    alt: 'accountingCredits',
  },
  accountingSoftware: {
    src: accountingSoftware,
    alt: 'accountingSoftware',
  },
  accounts: {
    src: accounts,
    alt: 'accounts',
  },
  accountsOn: {
    src: accountsOn,
    alt: 'accounts-on',
  },
  accountTransfer: {
    src: accountTransfer,
    alt: 'accountTransfer',
  },
  accountTransferOn: {
    src: accountTransferOn,
    alt: 'accountTransfer-on',
  },
  accountSettings: {
    src: accountSettings,
    alt: 'accountSettings',
  },
  accountSettingsOn: {
    src: accountSettingsOn,
    alt: 'accountSettings-on',
  },
  aicpaSoc: {
    src: aicpaSoc,
    alt: 'AICPA SOC',
  },
  add: {
    src: add,
    alt: 'add',
  },
  addAccount: {
    src: addAccount,
    alt: 'addAccount',
  },
  addAccountOn: {
    src: addAccountOn,
    alt: 'addAccount-on',
  },
  addContact: {
    src: addContact,
    alt: 'addContact',
  },
  addContactOn: {
    src: addContactOn,
    alt: 'addContact-on',
  },
  addNewClientAccount: {
    src: addNewClientAccount,
    alt: 'addNewClientAccount',
  },
  addNewClientAccountOn: {
    src: addNewClientAccountOn,
    alt: 'addNewClientAccount-on',
  },
  addPackage: {
    src: addPackage,
    alt: 'addPackage',
  },
  addPackageOn: {
    src: addPackageOn,
    alt: 'addPackage-on',
  },
  approvalInbox: {
    src: approvalInbox,
    alt: 'approvalInbox',
  },
  approvalInboxOn: {
    src: approvalInboxOn,
    alt: 'approvalInbox-on',
  },
  activity: {
    src: activity,
    alt: 'activity',
  },
  applePay: {
    src: applePay,
    alt: 'applePay',
  },
  approvalList: {
    src: approvalList,
    alt: 'approvalList',
  },
  approvalListOn: {
    src: approvalListOn,
    alt: 'approvalList-on',
  },
  transactionApproval: {
    src: transactionApproval,
    alt: 'transactionApproval',
  },
  transactionApprovalOn: {
    src: transactionApprovalOn,
    alt: 'transactionApproval-on',
  },
  approvalConfiguration: {
    src: approvalConfiguration,
    alt: 'approvalConfiguration',
  },
  approvalConfigurationOn: {
    src: approvalConfigurationOn,
    alt: 'approvalConfiguration-on',
  },
  alarm: {
    src: alarm,
    alt: 'alarm',
  },
  angleDown: {
    src: angleDown,
    alt: 'angle-down',
  },
  angleDown2: {
    src: angleDown2,
    alt: 'angle-down',
  },
  angleLeft: {
    src: angleLeft,
    alt: 'angle-left',
  },
  angleRight: {
    src: angleRight,
    alt: 'angle-right',
  },
  arrowDown: {
    src: arrowDown,
    alt: 'arrow-down',
  },
  arrowDown2: {
    src: arrowDown2,
    alt: 'arrow-down',
  },
  arrowLeft: {
    src: arrowLeft,
    alt: 'arrow-left',
  },
  angleTop: {
    src: angleTop,
    alt: 'angle-top',
  },
  arrowUp: {
    src: arrowUp,
    alt: 'arrow-up',
  },
  arrowRight: {
    src: arrowRight,
    alt: 'arrow-right',
  },
  arrowSmallRight: {
    src: arrowSmallRight,
    alt: 'arrow-small-right',
  },
  arrowTop: {
    src: arrowTop,
    alt: 'arrow-top',
  },
  asterisk: {
    src: asterisk,
    alt: 'asterisk',
  },
  autoBalance: {
    src: autoBalance,
    alt: 'autoBalance',
  },
  autoBalanceOn: {
    src: autoBalanceOn,
    alt: 'autoBalance-on',
  },
  autoBalanceTransfer: {
    src: autoBalanceTransfer,
    alt: 'autoBalanceTransfer',
  },
  autoBalanceTransferOn: {
    src: autoBalanceTransferOn,
    alt: 'autoBalanceTransfer-on',
  },
  bankAccountTransfer: {
    src: bankAccountTransfer,
    alt: 'bankAccountTransfer',
  },
  bankAccountTransferOn: {
    src: bankAccountTransferOn,
    alt: 'bankAccountTransfer-on',
  },
  badgeBlueGradient: {
    src: badgeBlueGradient,
    alt: 'badgeBlueGradient',
  },
  bank: {
    src: bank,
    alt: 'bank',
  },
  bank2: {
    src: bank2,
    alt: 'bank',
  },
  bank3: {
    src: bank3,
    alt: 'bank',
  },
  bank4: {
    src: bank4,
    alt: 'bank',
  },
  bankDark: {
    src: bankDark,
    alt: 'bank',
  },
  bankOn: {
    src: bankOn,
    alt: 'bank-on',
  },
  bankAccount: {
    src: bankAccount,
    alt: 'bank-account',
  },
  bankVerifyHistory: {
    src: bankVerifyHistory,
    alt: 'bankVerifyHistory',
  },
  bankVerifyHistoryOn: {
    src: bankVerifyHistoryOn,
    alt: 'bankVerifyHistory-on',
  },
  bill: {
    src: bill,
    alt: 'bill',
  },
  billing: {
    src: billing,
    alt: 'billing',
  },
  billingOn: {
    src: billingOn,
    alt: 'billing-on',
  },
  blockRed: {
    src: blockRed,
    alt: 'blockRed',
  },
  briefcase: {
    src: briefcase,
    alt: 'briefcase',
  },
  briefcaseOn: {
    src: briefcaseOn,
    alt: 'briefcase-on',
  },
  bulkCollection: {
    src: bulkCollection,
    alt: 'bulkCollection',
  },
  bulkCollectionOn: {
    src: bulkCollectionOn,
    alt: 'bulkCollection-on',
  },
  bulkPayment: {
    src: bulkPayment,
    alt: 'bulkPayment',
  },
  bulkPaymentOn: {
    src: bulkPaymentOn,
    alt: 'bulkPayment-on',
  },
  business: {
    src: business,
    alt: 'business',
  },
  businessAvatar: {
    src: businessAvatar,
    alt: 'business-avatar',
  },
  businessAvatarInactive: {
    src: businessAvatarInactive,
    alt: 'business-avatar-inactive',
  },
  calendar: {
    src: calendar,
    alt: 'calendar',
  },
  can: {
    src: can,
    alt: 'can',
  },
  calendar2: {
    src: calendar2,
    alt: 'calendar2',
  },
  calendarAccounting: {
    src: calendarAccounting,
    alt: 'calendarAccounting',
  },
  calendarPremium: {
    src: calendarPremium,
    alt: 'calendarPremium',
  },
  calendarSchedule: {
    src: calendarSchedule,
    alt: 'calendarSchedule',
  },
  card: {
    src: card,
    alt: 'card',
  },
  cashPickup: {
    src: cashPickup,
    alt: 'cashPickup',
  },
  cardAE: {
    src: cardAE,
    alt: 'card-ae',
  },
  cardDiscover: {
    src: cardDiscover,
    alt: 'card-discover',
  },
  cardMaster: {
    src: cardMaster,
    alt: 'card-master',
  },
  cardMaster2: {
    src: cardMaster2,
    alt: 'card-master',
  },
  cardVisa: {
    src: cardVisa,
    alt: 'card-visa',
  },
  cardVisa2: {
    src: cardVisa2,
    alt: 'card-visa',
  },
  cardDiners: {
    src: cardDiners,
    alt: 'card-diners',
  },
  cardJcb: {
    src: cardJcb,
    alt: 'card-jcb',
  },
  cautionary: {
    src: cautionary,
    alt: 'cautionary',
  },
  cautionary2: {
    src: cautionary2,
    alt: 'cautionary',
  },
  chat: {
    src: chat,
    alt: 'chat',
  },
  check: {
    src: check,
    alt: 'check',
  },
  check2: {
    src: check2,
    alt: 'check',
  },
  checkboxCheck: {
    src: checkboxCheck,
    alt: 'checkboxCheck',
  },
  checkGreen: {
    src: checkGreen,
    alt: 'checkGreen',
  },
  chevron: {
    src: chevron,
    alt: 'chevron',
  },
  checkGreenCircle: {
    src: checkGreenCircle,
    alt: 'check',
  },
  checkBlueGradient: {
    src: checkBlueGradient,
    alt: 'checkBlueGradient',
  },
  clientAccountList: {
    src: clientAccountList,
    alt: 'client-accountList',
  },
  clientAccountListOn: {
    src: clientAccountListOn,
    alt: 'client-accountList-on',
  },
  clientAccounts: {
    src: clientAccounts,
    alt: 'client-accounts',
  },
  clientAccountsOn: {
    src: clientAccountsOn,
    alt: 'client-accounts-on',
  },
  clock: {
    src: clock,
    alt: 'clock',
  },
  close: {
    src: close,
    alt: 'close',
  },
  close2: {
    src: close2,
    alt: 'close',
  },
  coin: {
    src: coin,
    alt: 'coin',
  },
  collaborators: {
    src: collaborators,
    alt: 'collaborators',
  },
  completed: {
    src: completed,
    alt: 'completed',
  },
  collection: {
    src: collection,
    alt: 'collection',
  },
  collectionOn: {
    src: collectionOn,
    alt: 'collection-on',
  },
  connections: {
    src: connections,
    alt: 'connections',
  },
  connectionsOn: {
    src: connectionOn,
    alt: 'connections-on',
  },
  contacts: {
    src: contacts,
    alt: 'contacts',
  },
  contactsOn: {
    src: contactsOn,
    alt: 'contacts-on',
  },
  contactsDownload: {
    src: contactsDownload,
    alt: 'contacts-download',
  },
  contactsDownloadOn: {
    src: contactsDownloadOn,
    alt: 'contacts-download-on',
  },
  contactsGradient: {
    src: contactsGradient,
    alt: 'contacts-gradient',
  },
  contactsUpload: {
    src: contactsUpload,
    alt: 'contacts-upload',
  },
  contactsUploadOn: {
    src: contactsUploadOn,
    alt: 'contacts-upload-on',
  },
  conversion: {
    src: conversion,
    alt: 'concersion',
  },
  conversionOn: {
    src: conversionOn,
    alt: 'conversion-on',
  },
  convert: {
    src: convert,
    alt: 'convert',
  },
  convertOn: {
    src: convertOn,
    alt: 'covert-on',
  },
  convertArrow: {
    src: convertArrow,
    alt: 'convertArrow',
  },
  copy: {
    src: copy,
    alt: 'copy',
  },
  counter: {
    src: counter,
    alt: 'counter',
  },
  cross: {
    src: cross,
    alt: 'cross',
  },
  crossborder: {
    src: crossborder,
    alt: 'crossborder',
  },
  crossborderOn: {
    src: crossborderOn,
    alt: 'crossborder-on',
  },
  create: {
    src: create,
    alt: 'create',
  },
  createSubAccount: {
    src: createSubAccount,
    alt: 'createSubAccount',
  },
  createSubAccountOn: {
    src: createSubAccountOn,
    alt: 'createSubAccount-on',
  },
  creditCard: {
    src: creditCard,
    alt: 'credit-card',
  },
  creditCard2: {
    src: creditCard2,
    alt: 'credit-card',
  },
  creditCard3: {
    src: creditCard3,
    alt: 'credit-card',
  },
  creditCard4: {
    src: creditCard4,
    alt: 'credit-card',
  },
  dashboardSmall: {
    src: dashboardSmall,
    alt: 'dashboard-small',
  },
  dashboardSmallOn: {
    src: dashboardSmallOn,
    alt: 'dashboard-small-on',
  },
  dashboard: {
    src: dashboard,
    alt: 'dashboard',
  },
  dashboardOn: {
    src: dashboardOn,
    alt: 'dashboard-on',
  },
  dateCalendar: {
    src: dateCalendar,
    alt: 'date-calendar',
  },
  developer: {
    src: developer,
    alt: 'developer',
  },
  developerDoc: {
    src: developerDoc,
    alt: 'developerDoc',
  },
  developerOn: {
    src: developerOn,
    alt: 'developer-on',
  },
  development: {
    src: development,
    alt: 'development',
  },
  dialogSuccess: {
    src: dialogSuccess,
    alt: 'success',
  },
  dispute: {
    src: dispute,
    alt: 'dispute',
  },
  document: {
    src: document,
    alt: 'document',
  },
  document2: {
    src: document2,
    alt: 'document2',
  },
  document3: {
    src: document3,
    alt: 'document3',
  },
  document4: {
    src: document4,
    alt: 'document4',
  },
  documentBulletPoints: {
    src: documentBulletPoints,
    alt: 'documentBulletPoints',
  },
  docuUpload: {
    src: docuUpload,
    alt: 'docuUpload',
  },
  dollar: {
    src: dollar,
    alt: 'dollar',
  },
  dollarCoin: {
    src: dollarCoin,
    alt: 'dollar-coin',
  },
  download: {
    src: download,
    alt: 'download',
  },
  edit: {
    src: edit,
    alt: 'edit',
  },
  edit2: {
    src: edit2,
    alt: 'edit2',
  },
  eLinxHistory: {
    src: eLinxHistory,
    alt: 'eLinxHistory',
  },
  eLinxHistoryOn: {
    src: eLinxHistoryOn,
    alt: 'eLinxHistory-on',
  },
  emptyBox: {
    src: emptyBox,
    alt: 'empty-box',
  },
  error: {
    src: error,
    alt: 'error',
  },
  error2: {
    src: error2,
    alt: 'error2',
  },
  error3: {
    src: error3,
    alt: 'error3',
  },
  exclamation: {
    src: exclamation,
    alt: 'exclamation',
  },
  errorRed: {
    src: errorRed,
    alt: 'errorRed',
  },
  errorRed2: {
    src: errorRed2,
    alt: 'errorRed',
  },
  expand: {
    src: expand,
    alt: 'expand',
  },
  eyeClose: {
    src: eyeClose,
    alt: 'eye-close',
  },
  eyeOpen: {
    src: eyeOpen,
    alt: 'eye-open',
  },
  ePay: {
    src: ePay,
    alt: 'e-Pay',
  },
  eConnect: {
    src: eConnect,
    alt: 'e-connect',
  },
  eCollect: {
    src: eCollect,
    alt: 'e-collect',
  },
  eFlex: {
    src: eFlex,
    alt: 'e-flex',
  },
  ePayOn: {
    src: ePayOn,
    alt: 'e-PayOn',
  },
  eConnectOn: {
    src: eConnectOn,
    alt: 'e-connectOn',
  },
  eCollectOn: {
    src: eCollectOn,
    alt: 'e-collectOn',
  },
  eFlexOn: {
    src: eFlexOn,
    alt: 'e-flexOn',
  },
  eft: {
    src: eft,
    alt: 'eft',
  },
  facebook: {
    src: facebook,
    alt: 'facebook',
  },
  fail: {
    src: fail,
    alt: 'fail',
  },
  fail2: {
    src: fail2,
    alt: 'fail2',
  },
  fail3: {
    src: fail3,
    alt: 'fail3',
  },
  faq: {
    src: faq,
    alt: 'faq',
  },
  faq2: {
    src: faq2,
    alt: 'faq2',
  },
  faq3: {
    src: faq3,
    alt: 'faq3',
  },
  faqOn: {
    src: faqOn,
    alt: 'faq-on',
  },
  fileDownload: {
    src: fileDownload,
    alt: 'fileDownload',
  },
  fednow: {
    src: fednow,
    alt: 'fednow',
  },
  fileDownloadOn: {
    src: fileDownloadOn,
    alt: 'fileDownload-on',
  },
  fileUpload: {
    src: fileUpload,
    alt: 'fileUpload',
  },
  fileUploadOn: {
    src: fileUploadOn,
    alt: 'fileUpload-on',
  },
  filter: {
    src: filter,
    alt: 'filter',
  },
  filter2: {
    src: filter2,
    alt: 'filter2',
  },
  filter2on: {
    src: filter2on,
    alt: 'filter2on',
  },
  folder: {
    src: folder,
    alt: 'folder',
  },
  folderOn: {
    src: folderOn,
    alt: 'folder-on',
  },
  fund: {
    src: fund,
    alt: 'fund',
  },
  fundOn: {
    src: fundOn,
    alt: 'fund-on',
  },
  global: {
    src: global,
    alt: 'global',
  },
  globe: {
    src: globe,
    alt: 'globe',
  },
  google: {
    src: google,
    alt: 'google',
  },
  googlePay: {
    src: googlePay,
    alt: 'googlePay',
  },
  graphIncreasing: {
    src: graphIncreasing,
    alt: 'graphIncreasing',
  },
  gridSquares: {
    src: gridSquares,
    alt: 'gridSquares',
  },
  gridSquaresAdd: {
    src: gridSquaresAdd,
    alt: 'gridSquaresAdd',
  },
  homeDoor: {
    src: homeDoor,
    alt: 'homeDoor',
  },
  home: {
    src: home,
    alt: 'home',
  },
  iconsGradient: {
    src: iconsGradient,
    alt: 'iconsGradient',
  },
  inactive: {
    src: inactive,
    alt: 'inactive',
  },
  income: {
    src: income,
    alt: 'income',
  },
  information: {
    src: information,
    alt: 'information',
  },
  infoCircle: {
    src: infoCircle,
    alt: 'information',
  },
  interac: {
    src: interac,
    alt: 'interac',
  },
  interacColor: {
    src: interacColor,
    alt: 'interacColor',
  },
  interac2: {
    src: interac2,
    alt: 'interac',
  },
  interestBank: {
    src: interestBank,
    alt: 'interestBank',
  },
  interacYellow: {
    src: interacYellow,
    alt: 'interac',
  },
  invoice: {
    src: invoice,
    alt: 'invoice',
  },
  invoiceOn: {
    src: invoiceOn,
    alt: 'invoice-on',
  },
  learningCenter: {
    src: learningCenter,
    alt: 'learningCenter',
  },
  learningCenterOn: {
    src: learningCenterOn,
    alt: 'learningCenter-on',
  },
  legoCyclopsMoustache: {
    src: legoCyclopsMoustache,
    alt: 'Lego Cyclopse Moustache (Contacts)',
  },
  line: {
    src: line,
    alt: 'line',
  },
  linkedin: {
    src: linkedin,
    alt: 'linkedin',
  },

  loader: {
    src: loader,
    alt: 'loader',
  },
  loaderCropped: {
    src: loaderCropped,
    alt: 'loader',
  },
  lock: {
    src: lock,
    alt: 'lock',
  },
  lock2: {
    src: lock2,
    alt: 'lock2',
  },
  logoELinx: {
    src: logoELinx,
    alt: 'logoELinx',
  },
  logOut: {
    src: logOut,
    alt: 'logout',
  },
  logOutOn: {
    src: logOutOn,
    alt: 'logout-on',
  },
  magnifyingGlass: {
    src: magnifyingGlass,
    alt: 'magnifying-glass',
  },
  mail: {
    src: mail,
    alt: 'mail',
  },
  mailGradient: {
    src: mailGradient,
    alt: 'mailGradient',
  },
  mobileMoney: {
    src: mobileMoney,
    alt: 'mobileMoney',
  },
  mailOutline: {
    src: mailOutline,
    alt: 'mail',
  },
  mobile: {
    src: mobile,
    alt: 'mobile',
  },
  moneyCalendar: {
    src: moneyCalendar,
    alt: 'moneyCalendar',
  },
  moneyCardPen: {
    src: moneyCardPen,
    alt: 'moneyCardPen',
  },
  money: {
    src: money,
    alt: 'money',
  },
  moneyOn: {
    src: moneyOn,
    alt: 'moneyOn',
  },
  multiply: {
    src: multiply,
    alt: 'multiply',
  },
  pen: {
    src: pen,
    alt: 'pen',
  },
  pending: {
    src: pending,
    alt: 'pending',
  },
  pendingClear: {
    src: pendingClear,
    alt: 'pending-clear',
  },
  multiBank: {
    src: multiBank,
    alt: 'multiBank',
  },
  myAccount: {
    src: myAccount,
    alt: 'myAccount',
  },
  myAccountOn: {
    src: myAccountOn,
    alt: 'myAccount-on',
  },
  myTeam: {
    src: myTeam,
    alt: 'myTeam',
  },
  myTeamOn: {
    src: myTeamOn,
    alt: 'myTeam-on',
  },
  notAllowed: {
    src: notAllowed,
    alt: 'not allowed',
  },
  operationalAccounts: {
    src: operationalAccounts,
    alt: 'operationalAccounts',
  },
  operationalAccountsOn: {
    src: operationalAccountsOn,
    alt: 'operationalAccounts-on',
  },
  outcome: {
    src: outcome,
    alt: 'outcome',
  },
  packages: {
    src: packages,
    alt: 'packages',
  },
  packagesOn: {
    src: packagesOn,
    alt: 'packages-on',
  },
  password: {
    src: password,
    alt: 'password',
  },
  payables: {
    src: payables,
    alt: 'payables',
  },
  payablesOn: {
    src: payablesOn,
    alt: 'payables-on',
  },
  paylink: {
    src: paylink,
    alt: 'paylink',
  },
  paylinkOn: {
    src: paylinkOn,
    alt: 'paylink-on',
  },
  payment: {
    src: payment,
    alt: 'payment',
  },
  paymentOn: {
    src: paymentOn,
    alt: 'payment-on',
  },
  paymentCard: {
    src: paymentCard,
    alt: 'payment-card',
  },
  paypal: {
    src: paypal,
    alt: 'paypal',
  },
  paypal2: {
    src: paypal2,
    alt: 'paypal',
  },
  pci: {
    src: pci,
    alt: 'pci',
  },
  pci2: {
    src: pci2,
    alt: 'pci',
  },
  pdfActive: {
    src: pdfActive,
    alt: 'pdf-active',
  },
  percentage: {
    src: percentage,
    alt: 'percentage',
  },
  personAvatar: {
    src: personAvatar,
    alt: 'person-avatar',
  },
  personAvatarInactive: {
    src: personAvatarInactive,
    alt: 'person-avatar-inactive',
  },
  personal: {
    src: personal,
    alt: 'personal',
  },
  phoneGradient: {
    src: phoneGradient,
    alt: 'phoneGradient',
  },
  picture: {
    src: picture,
    alt: 'picture',
  },
  positive: {
    src: positive,
    alt: 'positive',
  },
  photo: {
    src: photo,
    alt: 'photo',
  },
  production: {
    src: production,
    alt: 'production',
  },
  pull: {
    src: pull,
    alt: 'pull',
  },
  profile: {
    src: profile,
    alt: 'profile',
  },
  profile2: {
    src: profile2,
    alt: 'profile2',
  },
  question: {
    src: question,
    alt: 'question',
  },
  receipt: {
    src: receipt,
    alt: 'receipt',
  },
  receivables: {
    src: receivables,
    alt: 'receivables',
  },
  receivablesOn: {
    src: receivablesOn,
    alt: 'receivables-on',
  },
  refresh: {
    src: refresh,
    alt: 'refresh',
  },
  reports: {
    src: reports,
    alt: 'reports',
  },
  reportsOn: {
    src: reportsOn,
    alt: 'reports-on',
  },
  rtp: {
    src: rtp,
    alt: 'rtp',
  },
  sandbox: {
    src: sandbox,
    alt: 'sandbox',
  },
  scheduled: {
    src: scheduled,
    alt: 'scheduled',
  },
  scheduledOn: {
    src: scheduledOn,
    alt: 'scheduled-on',
  },
  scheduledClientAccountTransfers: {
    src: scheduledClientAccountTransfers,
    alt: 'scheduledClientAccountTransfers',
  },
  scheduledClientAccountTransfersOn: {
    src: scheduledClientAccountTransfersOn,
    alt: 'scheduledClientAccountTransfers-on',
  },
  summary: {
    src: summary,
    alt: 'summary',
  },
  summaryOn: {
    src: summaryOn,
    alt: 'summary-on',
  },
  search: {
    src: search,
    alt: 'search',
  },
  search2: {
    src: search2,
    alt: 'search',
  },
  searchData: {
    src: searchData,
    alt: 'search-data',
  },
  searchGradient: {
    src: searchGradient,
    alt: 'search-gradient',
  },
  serviceGlobalTransfer: {
    src: serviceGlobalTransfer,
    alt: 'serviceGlobalTransfer',
  },
  switchDisable: {
    src: switchDisable,
    alt: 'switch-disable',
  },
  switchEnable: {
    src: switchEnable,
    alt: 'switch-enable',
  },
  setting: {
    src: setting,
    alt: 'setting',
  },
  setting2: {
    src: setting2,
    alt: 'setting2',
  },
  sign: {
    src: sign,
    alt: 'sign',
  },
  soc: {
    src: soc,
    alt: 'soc',
  },
  star: {
    src: star,
    alt: 'star',
  },
  starOutline: {
    src: starOutline,
    alt: 'starOutline',
  },
  statePositive: {
    src: statePositive,
    alt: 'sign',
  },
  stateNeutral: {
    src: stateNeutral,
    alt: 'sign',
  },
  stateInfo: {
    src: stateInfo,
    alt: 'sign',
  },
  stateNegative: {
    src: stateNegative,
    alt: 'sign',
  },
  settingOn: {
    src: settingOn,
    alt: 'setting-on',
  },
  subAccount: {
    src: subAccount,
    alt: 'subAccount',
  },
  subAccountOn: {
    src: subAccountOn,
    alt: 'subAccount-on',
  },
  subAccountsList: {
    src: subAccountsList,
    alt: 'subAccountsList',
  },
  subAccountsListOn: {
    src: subAccountsListOn,
    alt: 'subAccountsList-on',
  },
  subTract: {
    src: subTract,
    alt: 'subTract',
  },
  support: {
    src: support,
    alt: 'support',
  },
  supportOn: {
    src: supportOn,
    alt: 'support-on',
  },
  swap: {
    src: swap,
    alt: 'swap',
  },
  sync: {
    src: sync,
    alt: 'sync',
  },
  ticket: {
    src: ticket,
    alt: 'ticket',
  },
  ticketOn: {
    src: ticketOn,
    alt: 'ticket-on',
  },
  ticketList: {
    src: ticketList,
    alt: 'ticketList',
  },
  ticketListOn: {
    src: ticketListOn,
    alt: 'ticketList-on',
  },
  training: {
    src: training,
    alt: 'training',
  },
  trainingOn: {
    src: trainingOn,
    alt: 'training-on',
  },
  transactionPending: {
    src: transactionPending,
    alt: 'transactionPending',
  },
  transactions: {
    src: transactions,
    alt: 'transactions',
  },
  transactionsOn: {
    src: transactionsOn,
    alt: 'transactionsOn',
  },
  transactionsHistory: {
    src: transactionsHistory,
    alt: 'transactionsHistory',
  },
  transactionsHistoryOn: {
    src: transactionsHistoryOn,
    alt: 'transactionsHistory-on',
  },
  transfer: {
    src: transfer,
    alt: 'transfer',
  },
  transferOn: {
    src: transferOn,
    alt: 'transferOn',
  },
  trashcan: {
    src: trashcan,
    alt: 'trashcan',
  },
  transferFunds: {
    src: transferFunds,
    alt: 'transferFunds',
  },
  transferFundsOn: {
    src: transferFundsOn,
    alt: 'transferFundsOn',
  },
  trash: {
    src: trash,
    alt: 'trash',
  },
  unSelectAll: {
    src: unSelectAll,
    alt: 'unSelectAll',
  },
  upload: {
    src: upload,
    alt: 'upload',
  },
  uploadOn: {
    src: uploadOn,
    alt: 'upload-on',
  },
  uploadHistory: {
    src: uploadHistory,
    alt: 'uploadHistory',
  },
  uploadHistoryOn: {
    src: uploadHistoryOn,
    alt: 'uploadHistory-on',
  },
  vLogo: {
    src: vLogo,
    alt: 'v-logo',
  },
  vLogoText: {
    src: vLogoText,
    alt: 'v-logo-vertical',
  },
  vLogoMark: {
    src: vLogoMark,
    alt: 'v-logo-mark',
  },
  vector: {
    src: vector,
    alt: 'vector',
  },
  venmo: {
    src: venmo,
    alt: 'venmo',
  },
  venmo2: {
    src: venmo2,
    alt: 'venmo',
  },
  video: {
    src: video,
    alt: 'video',
  },
  videoDisabled: {
    src: videoDisabled,
    alt: 'videoDisabled',
  },
  vopayLogo: {
    src: vopayLogo,
    alt: 'vopay-logo',
  },
  user: {
    src: user,
    alt: 'user',
  },
  userSettings: {
    src: userSettings,
    alt: 'userSettings',
  },
  userSettingsOn: {
    src: userSettingsOn,
    alt: 'userSettingsOn',
  },
  wallet: {
    src: wallet,
    alt: 'wallet',
  },
  walletOn: {
    src: walletOn,
    alt: 'wallet-on',
  },
  warning: {
    src: warning,
    alt: 'warning',
  },
  withdraw: {
    src: withdraw,
    alt: 'withdraw',
  },
  withdrawOn: {
    src: withdrawOn,
    alt: 'withdraw-on',
  },
  write: {
    src: write,
    alt: 'write',
  },
  i: {
    src: i,
    alt: 'i',
  },
  iOutlined: {
    src: iOutlined,
    alt: 'iOutlined',
  },
  eLinxE: {
    src: eLinxE,
    alt: 'eLinxE',
  },
  eLinxLogo: {
    src: eLinxLogo,
    alt: 'eLinx Logo',
  },
  importExport: {
    src: importExport,
    alt: 'importExport',
  },
  checkCircleFilled: {
    src: checkCircleFilled,
    alt: 'checkCircleFilled',
  },
  pendingStatus: {
    src: pendingStatus,
    alt: 'pendingStatus',
  },
};
